// extracted by mini-css-extract-plugin
module.exports = {"summary":"Summary_summary__2JVlX","summary__listSide":"Summary_summary__listSide__2c5N_","summary__tableSide":"Summary_summary__tableSide__2ih4X","sticky":"Summary_sticky__1amuT"};